'use strict';

import { service } from '@/plugins/feathers-client';

import * as getters from './getters';
import * as mutations from './mutations';
import * as actions from './actions';


export default service('comments', {
	getters,
	mutations,
	actions,
	state: {
		// @override
		setCurrentOnGet: false,
		setCurrentOnCreate: false,

		// @enhance
		editDialog: {
			visible: false,
			copy: {},
		},
	},
});
